import { render, staticRenderFns } from "./ProductStorageAndPricing.vue?vue&type=template&id=7564b08a&scoped=true&lang=pug&"
import script from "./ProductStorageAndPricing.vue?vue&type=script&lang=ts&"
export * from "./ProductStorageAndPricing.vue?vue&type=script&lang=ts&"
import style0 from "./ProductStorageAndPricing.vue?vue&type=style&index=0&id=7564b08a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7564b08a",
  null
  
)

export default component.exports